import { RegisteredTokenDetail } from "models/factory/RegisteredTokenResponse"
import { TokenInfoResponse } from "models/token/TokenInfoResponse"
import { useCoinhallToken } from "provider/CoinhallTokensProvider"
import { useNavigate } from "react-router-dom"
import { fromDenom, numberPendek } from "utils/Helpers"
import { showSimpleModal } from "utils/Modals"

type Props = {
    isVerified?: boolean,
    tokenDetail: RegisteredTokenDetail,
    tokenInfo: TokenInfoResponse,
    stakeAmount: number,
    rewardAmount: number,
    onShowModal: (tokenDetail: RegisteredTokenDetail, tokenInfo: TokenInfoResponse, stakeAmount: number, rewardAmount: number) => void,
}

export function AssetItem({ tokenInfo, tokenDetail, onShowModal, stakeAmount, rewardAmount, isVerified = true }: Props) {
    const tokens = useCoinhallToken()
    const navigate = useNavigate()

    const getIcon = () => tokens.find(e => e.id == tokenDetail.token_address)?.icon

    return <li className="d-flex pb-1 mt-3">
        {
            getIcon() && <div className="avatar flex-shrink-0 me-3">
                <img src={getIcon()} />
            </div>
        }

        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
            <div className="me-2">
                <h6 className="mb-0 cursor-pointer" onClick={() => navigate(`/${tokenDetail.staking_address}/asset`)}>
                    {tokenInfo.name} ({tokenInfo.symbol})
                    {
                        isVerified && <i onClick={() => showSimpleModal(
                            "Verified Staking Token",
                            <div className="d-flex align-items-center gap-1">
                                This token has been verified by the project owner but its not a recommendation from the platform. Stake with your own risk and always DYOR
                            </div>
                        )}
                            className="cursor-pointer bx ms-1 bx-tada-hover bx-check-shield text-success"></i>
                    }

                </h6>
                {/* <small className="text-muted">{numberPendek(fromDenom(rewardAmount, tokenInfo.decimals))} {tokenInfo.symbol}</small> */}
            </div>
            {/* <div className="user-progress">
                <small className="fw-semibold badge bg-label-success">{numberPendek(fromDenom(rewardAmount, tokenInfo.decimals))} {tokenInfo.symbol}</small>
            </div> */}
        </div>
        <div className="btn-group ms-3" role="group" aria-label="Basic example">
            <button
                onClick={() => onShowModal(tokenDetail, tokenInfo, stakeAmount, rewardAmount)}
                type="button"
                className="btn btn-outline-primary">Detailed</button>
        </div>
    </li>
}